module.exports = __webpack_public_path__ + "img/account_home.b5b1cb5f.svg";